import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckIcon } from './icons';
const activities = [{
  name: 'Sarah from Austin, TX',
  action: 'just claimed her copy',
  time: '2 min ago'
}, {
  name: 'Mark from Denver, CO',
  action: 'downloaded the bonus pack',
  time: '4 min ago'
}, {
  name: 'Linda from San Diego, CA',
  action: 'started the protocol',
  time: '7 min ago'
}, {
  name: 'James from Chicago, IL',
  action: 'just claimed his copy',
  time: '9 min ago'
}, {
  name: 'Emily from Portland, OR',
  action: 'left a 5-star review',
  time: '12 min ago'
}, {
  name: 'David from Miami, FL',
  action: 'unlocked the Cancer-Proof Kitchen',
  time: '15 min ago'
}];
export const SocialActivityTicker: React.FC = () => {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const showTimer = setTimeout(() => setVisible(true), 3500);
    return () => clearTimeout(showTimer);
  }, []);
  useEffect(() => {
    if (!visible) return;
    const interval = setInterval(() => {
      setIndex(prev => (prev + 1) % activities.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [visible]);
  if (!visible) return null;
  const activity = activities[index];
  return <div className="fixed bottom-4 left-4 z-40 max-w-[320px] pointer-events-none" data-id="element-251">
      <AnimatePresence mode="wait" data-id="element-252">
        <motion.div key={index} initial={{
        opacity: 0,
        x: -30,
        y: 10
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: -30
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="bg-white rounded-xl shadow-2xl border border-gold/30 p-3 flex items-center gap-3" data-id="element-253">
          <div className="bg-forest rounded-full p-2 shrink-0" data-id="element-254">
            <CheckIcon className="w-4 h-4 text-gold" data-id="element-255" />
          </div>
          <div className="min-w-0" data-id="element-256">
            <p className="text-sm font-bold text-forest-dark truncate" data-id="element-257">
              {activity.name}
            </p>
            <p className="text-xs text-charcoal/70 truncate" data-id="element-258">
              {activity.action}
            </p>
            <p className="text-[10px] uppercase tracking-wider text-charcoal/40 mt-0.5" data-id="element-259">
              {activity.time}
            </p>
          </div>
        </motion.div>
      </AnimatePresence>
    </div>;
};